export function isLatLng(str) {
  // Check for exactly one comma in the string
  if ((str.match(/,/g) || []).length !== 1) return false;

  // Split the string into two parts and trim whitespace
  const parts = str.split(',');
  if (parts.length !== 2) return false;
  const lat = parts[0].trim();
  const lng = parts[1].trim();

  // Check that both parts contain a dot (.)
  if (!lat.includes('.') || !lng.includes('.')) return false;

  // Convert to numbers
  const latNum = parseFloat(lat);
  const lngNum = parseFloat(lng);

  // Ensure the numbers are valid
  if (isNaN(latNum) || isNaN(lngNum)) return false;

  // Optionally, check valid ranges for latitude and longitude
  if (latNum < -90 || latNum > 90 || lngNum < -180 || lngNum > 180) return false;

  return true;
}
